import axios from 'axios';

// ✅ On local dev (`npm start`):      reads .env              → http://localhost:5000/api
// ✅ On live build (`npm run build`): reads .env.production   → https://carrental.oriesolutions.co.in/api
const API_BASE = process.env.REACT_APP_API_URL || 'https://carrental.oriesolutions.co.in/api';
const BASE     = process.env.REACT_APP_BASE_URL || 'https://carrental.oriesolutions.co.in';

export const API = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const BASE_URL = BASE;
